import { render } from "./VerticalContainerComponent.vue?vue&type=template&id=07900bfa&ts=true"
import script from "./VerticalContainerComponent?vue&type=script&lang=ts"
export * from "./VerticalContainerComponent?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/xebel/xebel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__